import React from "react";
import "./HeroInner.css";

function HeroInner({ title, subtitle, bg }) {
  return (
    <section
      className="hero-inner"
      style={{
        backgroundImage: `url(${bg})`
      }}
    >
      <div className="hero-overlay">
        <h1>{title}</h1>
        <p>{subtitle}</p>
      </div>
    </section>
  );
}

export default HeroInner;